import { t } from "ttag";

import type { ModalProps } from "@/shared/models/legacy-types";
import {
  CalendarMinimalisticIcon,
  Card,
  Dialog,
  VideoCameraIcon,
} from "@/shared/ui";

export const VideoConsultationModal = ({ show, onClose }: ModalProps) => {
  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={VideoCameraIcon}>
          <Dialog.Title>{t`Video Consultations`}</Dialog.Title>
          <Dialog.Description>
            {t`You will schedule an appointment to be seen by your provider.`}
            <br />
            {t`They will review the intake information live with you and discuss next steps on your weight management journey!`}
          </Dialog.Description>
        </Dialog.Header>

        <Card.Root>
          <Card.Content className="flex items-center gap-2.5">
            <CalendarMinimalisticIcon className="size-4 shrink-0" />
            <Card.Description className="font-medium">{t`If you already have your follow up scheduled you don't have to schedule a new session`}</Card.Description>
          </Card.Content>
        </Card.Root>
      </Dialog.Content>
    </Dialog.Root>
  );
};
